import React, { useState, Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { NavMenu } from '../NavMenu';
import { API_URL } from '../constant/URL';
async function signUpUser(objSignUp) {
    return axios.post(`${API_URL}` + 'api/Account/SignUp', objSignUp
    ).then(result => result.data);
}
export default function SignUp({ setToken }) {
    const [UserName, setUserName] = useState();
    const [Email, setUserEmail] = useState();
    const [Password, setPassword] = useState();
    const [ConfirmPassword, setConfirmPassword] = useState();
    const handleSubmit = async e => {
        e.preventDefault();
        const token = await signUpUser({
            UserName,
            Email,
            Password,
            ConfirmPassword
        });
        setToken(token);
        return <Redirect to='/surah/surah-list' />
    }
    return (
        <div className="app flex-row align-items-center" >
            <Container >
                <Row className="justify-content-center" >
                    <Col md="9" lg="7" xl="6" >
                        <CardGroup>
                            <Card className="p-2" >
                                <CardBody>
                                    <Form onSubmit={handleSubmit}>
                                        <div className="row" className="mb-2 pageheading" >
                                            SignUp
                                        </div>

                                        <InputGroup className="mb-3" >
                                            <Input name="username" type="text" required onChange={e => setUserName(e.target.value)} placeholder="Enter User Name" />
                                        </InputGroup >
                                        <InputGroup className="mb-3" >
                                            <Input name="email" type="text" required onChange={e => setUserEmail(e.target.value)} placeholder="Enter Email" />
                                        </InputGroup >
                                        <InputGroup className="mb-4" >
                                            <Input name="password" type="password" required onChange={e => setPassword(e.target.value)} placeholder="Enter Password" />
                                        </InputGroup >
                                        <InputGroup className="mb-4" >
                                            <Input name="confirmpassword" type="password" required onChange={e => setConfirmPassword(e.target.value)} placeholder="Enter Confirm Password" />
                                        </InputGroup >
                                        <Button color="success" block > SignUp</Button >
                                    </Form >
                                </CardBody >
                            </Card >
                        </CardGroup >
                    </Col >
                </Row >
            </Container >
        </div >
    )
}

SignUp.propTypes = {
    setToken: PropTypes.func.isRequired
}